module.exports = __webpack_public_path__ + "static/first_user_image1-19a6a5ad7d2716426cbbdab21fbfb89a.jpg";